<template>
  <div :class="$style['pt-notes-dialog']">
    <appointment-report-read :notesDetail="notesDetail"></appointment-report-read>
    <report-read-detail v-if="hasRead" ref="readForm" :notesDetail="notesDetail"></report-read-detail>
    <purchase-intention v-else ref="readForm" :notesDetail="notesDetail"></purchase-intention>
     <div class="button-div">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="primary" @click="cancel" plain>取消</el-button>
      </div>
  </div>
</template>

<script>
import appointmentReportRead from './appointment-report-read'
import reportReadDetail from './report-read-detail'
import purchaseIntention from './purchase-intention'
// 组件class前缀
const prefixCls = 'pt-notes-dialog'

export default {
  name: 'pt-notes-dialog',
  components: { appointmentReportRead, reportReadDetail, purchaseIntention },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    notesDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    hasRead: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    submit () {
      console.log(this.$refs.readForm)
      this.$refs.readForm.validate().then(formValue => {
        if (this.hasRead) {
          let data = {
            id: formValue.id,
            content: formValue.content
          }
          this.$emit('submit', data)
        } else {
          let data = {
            id: formValue.id,
            repurchaseIntention: formValue.repurchaseIntention
          }
          this.$emit('submitRepurchaseIntention', data)
        }
      })
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-notes-dialog{
  :global .el-button + .el-button{
      margin-left: 40px;
    }
}
</style>
